"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function commonCoreFact(name, foreignKeys, additionalGrain = []) {
    return {
        name,
        tableType: 'fact',
        grain: [],
        tableGrain: [
            'setting',
            'subcategory',
            'age_band',
            'gender',
            'membercategory',
            'src',
            ...additionalGrain,
        ],
        foreignKeys,
    };
}
const commonCoreMetricsCounty = commonCoreFact('common-core-benchmarks-metrics-county', ['county::key'], ['!county']);
const commonCoreMetricsMsaDivision = commonCoreFact('common-core-benchmarks-metrics-msa-division', ['cbsa::key'], ['msa']);
const commonCoreMetricsNational = commonCoreFact('common-core-benchmarks-metrics-national', ['country::key'], ['!country']);
const commonCoreMetricsState = commonCoreFact('common-core-benchmarks-metrics-state', ['state::key'], ['!state']);
const commonCorePercentileCounty = commonCoreFact('common-core-benchmarks-percentile-county', ['county::key'], ['!county', 'percentile']);
const commonCorePercentileMsaDivision = commonCoreFact('common-core-benchmarks-percentile-msa-division', ['cbsa::key'], ['msa', 'percentile']);
const commonCorePercentileNational = commonCoreFact('common-core-benchmarks-percentile-national', ['country::key'], ['!country', 'percentile']);
const commonCorePercentileState = commonCoreFact('common-core-benchmarks-percentile-state', ['state::key'], ['!state', 'percentile']);
const commonCoreRevisitsCounty = commonCoreFact('common-core-benchmarks-revisits-county', ['county::key'], ['!county']);
const commonCoreRevisitsMsaDivision = commonCoreFact('common-core-benchmarks-revisits-msa-division', ['cbsa::key'], ['msa']);
const commonCoreRevisitsNational = commonCoreFact('common-core-benchmarks-revisits-national', ['country::key'], ['!country']);
const commonCoreRevisitsState = commonCoreFact('common-core-benchmarks-revisits-state', ['state::key'], ['!state']);
const pomBenchMsaDivisionCat = {
    name: 'percent-of-medicare-benchmarks-msa-division-category',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        'msa_division',
        'type_of_service',
        'category',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'cbsa::key',
        'state::key',
    ],
};
const pomBenchMsaDivisionDrg = {
    name: 'percent-of-medicare-benchmarks-msa-division-drg',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        'msa_division',
        '!drg',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'drg::key',
        'cbsa::key',
        'state::key',
    ],
};
const pomBenchMsaDivision = {
    name: 'percent-of-medicare-benchmarks-msa-division',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        'msa_division',
        'type_of_service',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'cbsa::key',
        'state::key',
    ],
};
const pomBenchMsaDivisionMdc = {
    name: 'percent-of-medicare-benchmarks-msa-division-mdc',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        'msa_division',
        'year_key',
        'mdc',
        'metric_type',
    ],
    foreignKeys: [
        'cbsa::key',
        'state::key',
    ],
};
const pomBenchStateCat = {
    name: 'percent-of-medicare-benchmarks-state-category',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!state',
        'type_of_service',
        'category',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'state::key',
    ],
};
const pomBenchStateDrg = {
    name: 'percent-of-medicare-benchmarks-state-drg',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!state',
        '!drg',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'drg::key',
        'state::key',
    ],
};
const pomBenchState = {
    name: 'percent-of-medicare-benchmarks-state',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!state',
        'type_of_service',
        'year_key',
        'metric_type',
    ],
    foreignKeys: [
        'state::key',
    ],
};
const pomBenchStateMdc = {
    name: 'percent-of-medicare-benchmarks-state-mdc',
    tableType: 'fact',
    grain: [],
    tableGrain: [
        '!state',
        'year_key',
        'mdc',
        'metric_type',
    ],
    foreignKeys: [
        'state::key',
    ],
};
exports.default = [
    commonCoreMetricsCounty,
    commonCoreMetricsMsaDivision,
    commonCoreMetricsNational,
    commonCoreMetricsState,
    commonCorePercentileCounty,
    commonCorePercentileMsaDivision,
    commonCorePercentileNational,
    commonCorePercentileState,
    commonCoreRevisitsCounty,
    commonCoreRevisitsMsaDivision,
    commonCoreRevisitsNational,
    commonCoreRevisitsState,
    pomBenchMsaDivisionCat,
    pomBenchMsaDivisionDrg,
    pomBenchMsaDivision,
    pomBenchMsaDivisionMdc,
    pomBenchStateCat,
    pomBenchStateDrg,
    pomBenchState,
    pomBenchStateMdc,
];
